<template>
    <div class="col">
        <h3>Ändrat abonnemang</h3>
        <p>Skickas till kunder där abonnemanget ändrats.</p>
        <div class="d-flex mt-2 align-items-center">
            <button class="btn btn-primary" :disabled="poster.submitted" @click="posterPost()">
                <span class="spinner-border spinner-border-sm"></span>
                Skicka
            </button>
            <div class="ps-2" v-if="company.email_contract_changed_sent_at">
                <i>Senast skickat: {{ company.email_contract_changed_sent_at }}</i>
            </div>
        </div>
    </div>
</template>

<script>
import poster from '../../../../shared/mixins/poster'

export default {

    props: {
        company: {
            required: true
        }
    },

    mixins: [
        poster
    ],

    computed: {
        posterUrl () {
            return '/companies/' + this.company.id + '/sendContractChangedEmail'
        }
    },

    methods: {
        posterSuccess () {
            bus.$emit(
                'notify',
                'Mail om ändrat avtal skickat'
            )
            this.$emit('success')
        }
    }
}
</script>
